export default "__VITE_ASSET__DOe8U1I7__"